import React from 'react';
import { Link } from 'react-router-dom';
import { ESTATUS_PROSPECTO_LABELS, labelFromMap } from '../../services/prospectosCrmService';

export default function ProspectoDuplicadosAlert({ duplicados = [], onContinue, onCancel, continuing = false }) {
  if (!duplicados.length) {
    return null;
  }

  return (
    <section className="crm-prospectos-alert is-warning">
      <div className="crm-prospectos-alert-head">
        <div>
          <strong>Encontramos posibles prospectos duplicados.</strong>
          <p>Revisa las coincidencias antes de crear un registro nuevo.</p>
        </div>
        {onContinue ? (
          <div className="crm-prospectos-alert-actions">
            <button type="button" onClick={onCancel} disabled={continuing}>Revisar datos</button>
            <button type="button" className="is-primary" onClick={onContinue} disabled={continuing}>
              {continuing ? 'Guardando...' : 'Crear de todos modos'}
            </button>
          </div>
        ) : null}
      </div>
      <div className="crm-prospectos-duplicados-list">
        {duplicados.map((duplicado) => (
          <article key={duplicado.id || `${duplicado.telefono}-${duplicado.email}`}>
            <div>
              <strong>{duplicado.nombre}</strong>
              <span>{duplicado.telefono || duplicado.email || 'Sin contacto'}</span>
            </div>
            <div>
              <span>{duplicado.asesorNombre}</span>
              <span>{labelFromMap(ESTATUS_PROSPECTO_LABELS, duplicado.estatus)}</span>
            </div>
            <span>{duplicado.fechaCreacion}</span>
            {duplicado.id ? <Link to={`/admin/prospectos/${duplicado.id}`}>Abrir prospecto existente</Link> : null}
          </article>
        ))}
      </div>
    </section>
  );
}
